module.exports = __webpack_public_path__ + "img/616.da04f021.jpg";